var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.071,
    height: 48.133,
    viewBox: "0 0 183.071 48.133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-484.211 -412.211)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 26.507,
    transform: "translate(489.877 455.556)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.565,
    y2: 38.556,
    transform: "translate(489 417)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.565,
    y1: 38.556,
    transform: "translate(511.565 417)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.991,
    y2: 38.556,
    transform: "translate(534.13 417)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.991,
    y1: 38.556,
    transform: "translate(550.121 417)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    y1: 38.556,
    x2: 15.991,
    transform: "translate(566.111 417)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x2: 17.745,
    transform: "translate(582.98 417)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x2: 17.44,
    transform: "translate(583.285 455.556)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,441.508s13.052-1.267,12.881,20.943",
    transform: "translate(-1360.776 -24.495)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,459.082s13.052,1.064,12.881-17.588",
    transform: "translate(-1360.776 -3.538)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,451.133s7.921.583,7.818-9.638",
    transform: "translate(-1305.537 4.417)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,441.5s7.921-.583,7.818,9.638",
    transform: "translate(-1305.537 -24.495)",
    fill: "none",
    stroke: "#810000",
    strokeLinecap: "round",
    strokeWidth: 7,
    strokeDasharray: "0 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1969.32,451.133s-7.921.583-7.818-9.638",
    transform: "translate(-1333.328 4.417)",
    fill: "none",
    stroke: "#810000",
    strokeLinecap: "round",
    strokeWidth: 7,
    strokeDasharray: "0 12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1969.32,441.5s-7.921-.583-7.818,9.638",
    transform: "translate(-1333.328 -24.495)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1961.5,441.5s7.921-.583,7.818,9.638",
    transform: "translate(-1305.537 -5.163)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1969.32,451.133s-7.921.583-7.818-9.638",
    transform: "translate(-1333.352 -14.833)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x2: 21.36,
    transform: "translate(635.044 455.556)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x2: 21.36,
    transform: "translate(635.044 417)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x2: 19.982,
    transform: "translate(635.962 436.361)",
    fill: "none",
    stroke: "#d2d2d2",
    strokeLinecap: "round",
    strokeWidth: 7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/Header_Logo.7ff9961ce475d8ae461b751af2dd5ccd.svg";
export { ForwardRef as ReactComponent };